import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['status']);
  const updatePaymentStatus = `updatePaymentStatus(input: ${dataModify})`;
  return gql`
  mutation {
    ${updatePaymentStatus} {
      id
    }
  }
`;
};
